import { ISettingRepository } from '@/coreInfrastructureModule/interfaces/ISettingRepository';
import { DashboardAlertSetting } from '../domains/entities/DashboardAlert';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { ApiDashboardAlertSetting } from '@/coreInfrastructureModule/axios/generated/settingManage';

/**
 * ダッシュボード設定をPutする
 */
export class PutDashboardAlertSettingUseCase {
  private repository: ISettingRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: ISettingRepository) {
    this.repository = repository;
  }

  /**
   * ダッシュボードアラート設定を保存する
   * @param request - 変更する設定値
   */
  public async execute(request: DashboardAlertSetting): Promise<INetworkResult<void, IError>> {
    try {
      const currentMonthForecastAccuracyThreshold = request.critical.shortage.currentMonthForecastAccuracyThreshold;
      if (currentMonthForecastAccuracyThreshold == null) throw new Error();
      const apiRequest: ApiDashboardAlertSetting = {
        ...request,
        critical: {
          ...request.critical,
          shortage: {
            ...request.critical.shortage,
            currentMonthForecastAccuracyThreshold,
          },
        },
      };
      const result = await this.repository.putDashboardAlertSetting(apiRequest);
      switch (result.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: undefined,
            },
          };
        case 'error':
          console.error(result.status.error);
          return {
            status: {
              type: 'error',
              error: result.status.error,
            },
          };
      }
    } catch (e) {
      console.error('error', e); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: 'An unexpected error occurred',
          },
        },
      };
    }
  }
}
